import {useGetSessionUser} from '../../core/use-get-session-user';
import {PageContainer} from '../../layout';
import {PageWrapper} from '../../layout/page-wrapper';
import {FeatureGatePageWrapper} from '../../limits/feature-gates/feature-gate-page-wrapper';

import {getPageTitleBar} from '../helpers';

type Props = {
    isEmbedded?: boolean;
};

export const InboxNoAccessPage = (props: Props) => {
    const {user} = useGetSessionUser();

    return (
        <PageWrapper>
            <PageContainer
                title='Engagement'
                pageTitleBar={getPageTitleBar(
                    'engagement',
                    null,
                    null,
                    false,
                    () => {},
                    () => {}
                )}
                darkBackground={true}
                noPadding={true}
            >
                <FeatureGatePageWrapper
                    header='Connect with customers through the Engagement Suite'
                    subHeader='Engagement Suite offers a convenient way to communicate, keeping your connections strong and responsive using SMS, Chat, Facebook Messenger, Instagram, and WhatsApp.'
                    bullets={[
                        'Reach out to leads and customers directly on their phones for quick conversations.',
                        'Grow your outreach and make connections in a space they’re comfortable with.',
                        'Get instant notifications for new messages and thread assignments to stay in the loop.',
                        'Schedule automated texts to keep the conversation flowing at important moments in your sales journey.',
                    ]}
                    feature='SmsWithLicense'
                    shouldShowButton={Boolean(
                        user && user.permissions.canAccessSetup && !props.isEmbedded
                    )}
                    needLicenses={true}
                />
            </PageContainer>
        </PageWrapper>
    );
};
